import { Atom, atom } from 'jotai'
import { alphamapClient } from 'src/clients'
import { AMOwnershipGetParcelByIdResponse, AMParcelOverview } from 'src/common-services'
import { atomFamily } from 'src/utils/jotai'
import turf from 'src/utils/turf'
import * as atoms from 'src/v2/state/owner-reveal'
import { propertyRecordsForPosition } from 'src/v2/state/owner-reveal/property-records'
import { zoningByCoordinates } from 'src/v2/state/owner-reveal/zoning'

export const selectedParcelId = atom<string | undefined>(undefined)

export const selectedParcel = atom<Promise<AMOwnershipGetParcelByIdResponse | undefined>>(async (get) => {
  const id = get(selectedParcelId)
  if (!id) {
    return undefined
  }

  const parcel = await get(parcelById(id))
  return parcel
})

const parcelById = atomFamily<string, Atom<Promise<AMOwnershipGetParcelByIdResponse>>>((id) =>
  atom(async () => {
    const parcel = await alphamapClient.ownership.getParcelById(id)
    return parcel
  })
)

export const selectedParcelCentroid = atom(async (get) => {
  const parcel = await get(selectedParcel)
  if (!parcel) {
    return undefined
  }

  return turf.centroid(parcel.geometry).geometry.coordinates
})

export const selectedParcelZoningDetails = atom(async (get) => {
  const centroid = await get(selectedParcelCentroid)
  if (!centroid) {
    return undefined
  }

  const [lng, lat] = centroid
  const { mCode, zoneDetails } = await get(zoningByCoordinates({ lat, lng }))
  return { mCode, zoneDetails }
})

export const selectedParcelPropertyRecords = atom(async (get) => {
  const centroid = await get(selectedParcelCentroid)
  if (!centroid) {
    return undefined
  }
  const data = await get(propertyRecordsForPosition(centroid))
  return data?.[0]
})

export const selectedEntityParcelsOverview = atom(async (get) => {
  const entityId = await get(atoms.selectedEntityId)
  if (!entityId) {
    return undefined
  }
  return await get(entityParcelsOverviewById(entityId))
})

export const selectedEntityGraphParcelsCount = atom(async (get) => {
  const parcels = await get(selectedEntityParcelsOverview)
  return parcels ? parcels.length : 0
})

export const entityParcelsOverviewById = atomFamily<string, Atom<Promise<AMParcelOverview[] | undefined>>>((id) =>
  atom(async () => {
    const data = await alphamapClient.ownership.getEntityParcelsOverview(id)
    return data
  })
)
